import { AppShell } from '../../components/layout/AppShell';

export const DeliveryPage: React.FC = () => {

  return (
    <AppShell>
      <div className="space-y-6">
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">Delivery management page coming soon...</p>
        </div>
      </div>
    </AppShell>
  );
};
